import { createReducer } from '@reduxjs/toolkit';

import { ADVICE_ID } from 'constants/Parameters';
import { FETCH_ENTITY_SUCCESS } from 'modules/entity/actionTypes';
import { SET_SELECTED_GROUP_OFFER } from 'modules/works/actionTypes';
import { CHECKLIST_GROUP_STATUS } from 'modules/entity/subEntities/intervention/constants';
import { isChecklistGroupNotDisplayable } from 'modules/works/selectors/checklistGroups';

/** @typedef {string} SelectedGroupOfferState */

/** @type {SelectedGroupOfferState} */
const initialValue = null;

/**
 * @param {SelectedGroupOfferState} _
 * @param {import('modules/entity/subEntities/intervention/types').FetchInterventionSuccessAction} action
 * @returns {SelectedGroupOfferState}
 */
const initialize = (_, { payload: { checklistGroups = [], checklists = [] } }) => {
  const { checklistGroupId } =
    checklists.find(
      /** @param {import('types/Works').Checklist} checklist */ (checklist) =>
        checklist.items?.some((item) => item.advices?.some((advice) => advice.adviceId === ADVICE_ID))
    ) ?? {};

  return (
    checklistGroupId ??
    checklistGroups.find(({ status }) => status === CHECKLIST_GROUP_STATUS.ACCEPTED)?.id ??
    checklistGroups.find(({ id }) => !isChecklistGroupNotDisplayable(checklists, id))?.id ??
    checklistGroups[0]?.id ??
    initialValue
  );
};

const set = (_, { payload: id }) => id;

export default createReducer(initialValue, (builder) => {
  builder.addCase(FETCH_ENTITY_SUCCESS, initialize).addCase(SET_SELECTED_GROUP_OFFER, set);
});
